import React, { useEffect, useState } from 'react'
import { Button, Col, Form, Image, Row } from 'react-bootstrap'
import LabelCustomSmall from '../../label-custom-small'
import ImgUser from '../../../images/user.png'
import {
  createTransferOrgAPI,
  getTransferAPI
} from '../../../services/transfer'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import moment from 'moment'
import { Controller, useForm } from 'react-hook-form'
import Autocomplete from '../../custom/autocomplete'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import UseGroups from '../../../hooks/use-groups'
import UseTeams from '../../../hooks/use-teams'
import UseDepartments from '../../../hooks/use-departments'
import UsePositions from '../../../hooks/use-position'
import { getEmpsChkCodeAPI } from '../../../services/employee'
import UseFactions from '../../../hooks/use-factions'
import DatepickerCustom from '../../datepicker-custom'
import EmployeeImg from '../../../images/Employee.svg'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../error/error-false'
import UseEmpsReportby from '../../../hooks/use-emps-reportby'
import { useDebounce } from '@react-hook/debounce'
import InputNumber from '../../input-number'
import Error_500 from '../../error/error-500'
import { useSelector } from 'react-redux'
import ImageLoading from '../../../images/loading.svg'
import UseAllOrganization from '../../../hooks/use-org-all'

export default function DetailEmployeeTranOrg() {
  const [getFnData] = useOutletContext()

  const roleId = useSelector((state) => state.roleReducer.role)
  const [errorYup, setErrorYup] = useState()
  const schema = yup.object(errorYup).required()

  let [searchParams, setSearchParams] = useSearchParams()
  const uuid = searchParams.get('uuid')

  const [keyCode, setKeyCode] = useDebounce('', 1000)
  const [data, setData] = useState()
  const [orgId, setorgId] = useState(0)
  const [divisionId, setDivisionId] = useState(0)
  const [factionId, setFactionId] = useState(0)
  const [departmentId, setDepartmentId] = useState(0)
  const [teamId, setTeamId] = useState(0)
  const [isSave, setIsSave] = useState(false)
  const [isCode, setIsCode] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [isCodeAuto, setIsCodeAuto] = useState(false)
  const divisions = UseGroups(orgId) //สายงาน
  const factions = UseFactions(orgId, divisionId, factionId, departmentId) //ฝ่าย
  const department = UseDepartments(orgId, divisionId, factionId, departmentId) //แผนก
  const teams = UseTeams(orgId, divisionId, departmentId) //ทีม
  const positions = UsePositions(orgId, divisionId, departmentId, teamId) //ตำแน่ง
  const [keyReportTo, setKeyReportTo] = useDebounce('', 1000)

  const reportTo = UseEmpsReportby(orgId, keyReportTo)
  const {
    control,
    setValue,
    setError,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  useEffect(() => {
    const _error = {
      // code: yup.string().min(5).required('กรุณาระบุรหัสพนักงาน'),
      ...(!isCodeAuto && {
        code: yup.string().min(5).required('กรุณาระบุรหัสพนักงาน')
      }),
      divisions: yup.object().required('กรุณาระบุสายงาน'),
      department: yup.object().required('กรุณาระบุแผนก'),
      faction: yup.object().required('กรุณาระบุฝ่าย'),
      team: yup.object().required('กรุณาระบุทีม'),
      position: yup.object().required('กรุณาระบุตำแหน่ง'),
      level_id: yup.string().required('กรุณาระบุเลเวล'),
      endDate: yup.string().required('กรุณาระบุวันที่มีผล'),
      reportTo: yup.object().required('กรุณาระบุผู้บังคับบัญชา'),
      org2: yup.object().required('กรุณาระบุบริษัท')
    }
    setErrorYup(_error)
  }, [isCodeAuto])

  const optionOrg = UseAllOrganization()

  useEffect(() => {
    if (keyCode && orgId) {
      const getEmpsChkCode = async () => {
        const data = await getEmpsChkCodeAPI({
          orgId,
          searchs: keyCode
        })
        if (!data) return
        if (data.status) {
          setValue('checkCode', data.result.status)
          setIsCode(data.result.status)
        }
      }
      getEmpsChkCode()
    }
  }, [keyCode, orgId, setError, setValue])

  useEffect(() => {
    if (uuid) {
      getTransfer()
      reset()
    }
  }, [uuid])

  const getTransfer = async () => {
    try {
      setIsLoading(true)

      const res = await getTransferAPI({ uuid })
      setIsLoading(false)

      if (!res) return
      if (res.status) {
        setData(res.result)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const onSubmit = (data) => {
    const d = data
    const body = {
      orgId: d.org2.value ?? '',
      oldUuid: uuid,
      code: d.code,
      dsId: d.divisions?.value,
      facId: d.faction.value,
      dmId: d.department?.value,
      positionId: d.position.value,
      reportTo: d.reportTo?.value,
      teamId: d.team.value,
      effectiveDate: d.endDate
    }
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to save the changes?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        createTransfer(body)
      }
    })
  }

  const createTransfer = async (body) => {
    try {
      const res = await createTransferOrgAPI(body)
      setIsSave(false)
      if (!res) return
      if (res.status) {
        SwalCustom({
          title: 'Success!',
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          setSearchParams({})
          getFnData()
        })
      } else {
        Error_false(res)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  //set org not similar
  // useEffect(() => {

  //   if (optionOrg.length>0) {
  //     const filteredData = optionOrg.filter((item) => item?.value !== roleId)
  //     setOrgs(filteredData)
  //   }
  // }, [optionOrg])

  const onChangOrg = (id) => {
    const to_year = moment(new Date()).add(543, 'year').format('YY')
    let _short = optionOrg.find((item) => `${item.id}` === `${id}`)
    setValue('code', `${_short?.emp_code ?? ''}${to_year}`)
  }

  return isLoading ? (
    <div className="text-center">
      <Image src={ImageLoading} fluid />
    </div>
  ) : (
    <>
      {uuid ? (
        <>
          <Row
            className="border-bottom pb-3 pt-3 position-sticky bg-white mb-4"
            style={{ top: 0, position: 'sticky', zIndex: 100 }}
          >
            <Col
              xl={12}
              className="d-flex justify-content-between fw-light small"
            >
              <div className="d-flex ">
                <Image
                  fluid
                  className="rounded-circle "
                  style={{ maxWidth: 60, maxHeight: 60, objectFit: 'cover' }}
                  src={data?.img_url || ImgUser}
                  onError={(event) => {
                    event.target.src = ImgUser
                    event.onerror = null
                  }}
                />
                <div className="ms-3 my-auto">
                  <p
                    className="mb-2 box-text-1"
                    style={{
                      fontSize: 14
                    }}
                  >
                    {`${data?.title_en || '-'} ${data?.name_en || '-'} ${
                      data?.surname_en || '-'
                    }`}
                  </p>
                  <p
                    className="mb-0 box-text-1"
                    style={{
                      fontSize: 12
                    }}
                  >
                    {`${data?.title_th || '-'}${data?.name_th || '-'} ${
                      data?.surname_th || '-'
                    } (${data?.nickname_th || '-'})`}
                  </p>
                </div>
              </div>
              <div className="my-auto">
                <p
                  className="mb-2 box-text-1"
                  style={{
                    fontSize: 14
                  }}
                >
                  {`${
                    data?.start_date
                      ? moment(data.start_date).format('DD MMMM YYYY')
                      : '-'
                  } ( ${data?.date_applied_job} )`}
                </p>
                <p
                  className="mb-0 box-text-1"
                  style={{
                    fontSize: 12
                  }}
                >
                  {`${data?.shift || '-'} (${
                    data?.start_time
                      ? moment(data.start_time, 'HH:mm:ss').format('HH:mm')
                      : '-'
                  } - ${
                    data?.end_time
                      ? moment(data.end_time, 'HH:mm:ss').format('HH:mm')
                      : '-'
                  }) `}
                </p>
              </div>
              <div className="my-auto">
                <p
                  className="mb-2 box-text-1"
                  style={{
                    fontSize: 14
                  }}
                >
                  {data?.email || '-'}
                </p>
                <p
                  className="mb-0 box-text-1"
                  style={{
                    fontSize: 12
                  }}
                >
                  {data?.phone || '-'}
                </p>
              </div>
            </Col>
          </Row>
          <Form
            id="transferEmp"
            className="p-2"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="g-3">
              <ColFrom>
                <LabelCustomSmall>01 Organization</LabelCustomSmall>

                <Form.Control value={data?.org} disabled />
              </ColFrom>

              <ColFrom>
                <span className="d-flex justify-content-center m-4 small fw-light">
                  to
                </span>
              </ColFrom>

              <ColFrom>
                <LabelCustomSmall></LabelCustomSmall>

                <Controller
                  name={'org2'}
                  control={control}
                  render={({ field: { value = null, onChange } }) => (
                    <Autocomplete
                      value={value}
                      options={
                        optionOrg.length > 0
                          ? (optionOrg.filter(
                              (item) => item?.value !== roleId
                            ) ?? [])
                          : []
                      }
                      onChange={(res) => {
                        onChange(res)
                        onChangOrg(res.value)

                        setIsCodeAuto(res.isCodeAuto ?? false)
                        setValue('org2', res)

                        // setError('divisions', {})
                        setValue('divisions')
                        setValue('department')
                        setValue('team')
                        setValue('position')
                        setValue('level_id', '')
                        setValue('faction')

                        setorgId(res.value + '')
                        setDivisionId(0)
                        setFactionId(0)
                        setDepartmentId(0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.org2?.message && (
                  <label className="small text-danger">
                    {errors.org2.message}
                  </label>
                )}
              </ColFrom>
              <>
                <div className="d-flex mb-3 row">{/* Organization */}</div>
              </>
            </Row>
            <div className="border-top mb-3 d-flex"></div>

            <Row className="g-3">
              {/* Code */}
              <ColFrom>
                <LabelCustomSmall>02 รหัสพนักงาน</LabelCustomSmall>

                <Controller
                  name={'code'}
                  control={control}
                  render={({ field: { value = `` } }) => (
                    <InputNumber
                      disabled={isCodeAuto}
                      className={`${
                        !isCode && keyCode ? 'text-danger border-danger' : ''
                      }`}
                      maxLength={10}
                      value={value}
                      onChange={(d) => {
                        setValue('code', d.target.value)
                        setKeyCode(d.target.value)
                      }}
                    />
                  )}
                />
                {!isCode && keyCode && (
                  <label className="small text-danger">
                    รหัสพนักงานนี้มีในระบบแล้ว
                  </label>
                )}
                {errors.code?.message && (
                  <label className="small text-danger">
                    {errors.code.message}
                  </label>
                )}
              </ColFrom>
              {/* division */}
              <ColFrom>
                <LabelCustomSmall>03 สายงาน</LabelCustomSmall>

                <Controller
                  name={'divisions'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      options={divisions}
                      onChange={(res) => {
                        setError('divisions', res)
                        setValue('divisions', res)

                        setValue('faction')
                        setValue('department')
                        setValue('team')
                        setValue('position')
                        setValue('level_id', '')

                        setDivisionId(res.value + '')
                        setFactionId(0)
                        setDepartmentId(0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.divisions?.message && (
                  <label className="small text-danger">
                    {errors.divisions.message}
                  </label>
                )}
              </ColFrom>
              {/* faction */}
              <ColFrom>
                <LabelCustomSmall>04 ฝ่าย</LabelCustomSmall>
                <Controller
                  name={'faction'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      disabled={divisionId > 0 ? false : true}
                      value={value}
                      options={factions}
                      onChange={(res) => {
                        setError('faction', res)
                        setValue('faction', res)

                        setValue('department')
                        setValue('team')
                        setValue('position')
                        setValue('level_id', '')

                        setFactionId(res.value)

                        setDepartmentId(0)
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.faction?.message && (
                  <label className="small text-danger">
                    {errors.faction.message}
                  </label>
                )}
              </ColFrom>
              {/* department */}
              <ColFrom>
                <LabelCustomSmall>05 แผนก</LabelCustomSmall>
                <Controller
                  name={'department'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={factionId > 0 ? false : true}
                      options={department}
                      onChange={(res) => {
                        setDepartmentId(res.value)
                        setError('department', res)
                        setValue('department', res)

                        // setDivisionId(res.value + '')
                        setValue('team')
                        setValue('position')
                        setValue('level_id', '')
                        setTeamId(0)
                      }}
                    />
                  )}
                />
                {errors.department?.message && (
                  <label className="small text-danger">
                    {errors.department.message}
                  </label>
                )}
              </ColFrom>

              {/* team */}
              <ColFrom>
                <LabelCustomSmall>06 ทีม</LabelCustomSmall>
                <Controller
                  name={'team'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={departmentId > 0 ? false : true}
                      options={teams}
                      onChange={(res) => {
                        setTeamId(res.value)
                        setValue('team', res)
                        setError('team', res)

                        setValue('position')
                        setValue('level_id', '')
                      }}
                    />
                  )}
                />
                {errors.team?.message && (
                  <label className="small text-danger">
                    {errors.team.message}
                  </label>
                )}
              </ColFrom>
              {/* position */}
              <ColFrom>
                <LabelCustomSmall>07 ตำแหน่ง</LabelCustomSmall>
                <Controller
                  name={'position'}
                  control={control}
                  render={({ field: { value = {} } }) => (
                    <Autocomplete
                      value={value}
                      disabled={teamId > 0 ? false : true}
                      options={positions}
                      onChange={(res) => {
                        setValue('position', res)
                        setError('position', res)
                        setValue('level_id', res.level_id)
                        setError('level_id', res.level_id)
                      }}
                    />
                  )}
                />
                {errors.position?.message && (
                  <label className="small text-danger">
                    {errors.position.message}
                  </label>
                )}
              </ColFrom>
              {/* level */}
              <ColFrom>
                <LabelCustomSmall>08 Level</LabelCustomSmall>
                <Controller
                  name={'level_id'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Form.Control readOnly value={value} onChange={onChange} />
                  )}
                />
                {errors.level_id?.message && (
                  <label className="small text-danger">
                    {errors.level_id.message}
                  </label>
                )}
              </ColFrom>
              {/* effective date */}
              <ColFrom>
                <LabelCustomSmall>09 วันที่มีผล</LabelCustomSmall>
                <Controller
                  name={'endDate'}
                  control={control}
                  render={({ field: { value = '', onChange } }) => (
                    <DatepickerCustom
                      value={value}
                      // defaultValue={moment().toDate()}
                      onChange={([date]) => {
                        onChange(date ? moment(date).format('YYYY-MM-DD') : '')
                        setValue(
                          'endDate',
                          date ? moment(date).format('YYYY-MM-DD') : ''
                        )
                      }}
                    />
                  )}
                />
                {errors.endDate?.message && (
                  <label className="small text-danger">
                    {errors.endDate.message}
                  </label>
                )}
              </ColFrom>
              {/* reportTo */}
              <ColFrom>
                <LabelCustomSmall>10 ผู้บังคับบัญชา</LabelCustomSmall>
                <Controller
                  name={'reportTo'}
                  control={control}
                  render={({ field: { onChange, value = '' } }) => (
                    <Autocomplete
                      isClearable={true}
                      options={reportTo}
                      value={value}
                      onChange={onChange}
                      onInputChange={(data) => {
                        setKeyReportTo(data)
                      }}
                    />
                  )}
                />
                {errors.reportTo?.message && (
                  <label className="small text-danger">
                    {errors.reportTo.message}
                  </label>
                )}
              </ColFrom>
            </Row>
          </Form>

          <div className="m-5 d-flex justify-content-center">
            <Button
              className="px-5"
              disabled={isSave}
              type="submit"
              form="transferEmp"
            >
              Transfer{isSave && 'ring...'}
            </Button>
          </div>
        </>
      ) : (
        <>
          <div
            className="d-flex justify-content-center"
            style={{
              paddingTop: 200,
              paddingBotton: 200
            }}
          >
            <Image src={EmployeeImg} width={200} />
          </div>
          {roleId ? (
            <p
              className="text-secondary text-center fw-bold mt-2 pe-3 pl-3"
              style={{
                opacity: 0.5,
                fontSize: 20
              }}
            >
              Please Select The Employee To Be Transferred.
            </p>
          ) : (
            <p
              className="text-secondary text-center fw-bold mt-2 pe-3 pl-3"
              style={{
                opacity: 0.5,
                fontSize: 20
              }}
            >
              - ไม่พบ ORG ของท่านในระบบ โปรดติดต่อแผนก IT -
            </p>
          )}
        </>
      )}
    </>
  )
}
const ColFrom = (props) => {
  const { children, className = '', ...other } = props

  return (
    <Col xl={4} xs={6} md={4} className={` ${className}`} {...other}>
      {children}
    </Col>
  )
}
